import React from 'react';
import './advantagesSection.scss';
import {useTranslation} from "react-i18next";

const AdvantagesSection = () => {
	const { t } = useTranslation();

	return (
		<div className="advantages">
			<div className="advantages__content">
				<div className="advantages__content_header">
					<h3>{t('advantages.title')}</h3>
				</div>
				<div className="advantages__content_table">
					<div className="advantages__content_table_item">
						<div className="title">
							<span className="title">{t('gentleMegagrip.title')}</span>
						</div>
						<div className="items">
							<div className="item">
								<span className="item_text">{t('advantages.gentleMegagrip.fitsPerfectly')}</span>
							</div>
							<div className="item">
								<span className="item_text">{t('advantages.gentleMegagrip.doesNotPull')}</span>
							</div>
						</div>
					</div>

					<div className="advantages__content_table_item">
						<div className="title">
							<span className="title">{t('advantages.sustainable.title')}</span>
						</div>
						<div className="items">
							<div className="item">
								<span className="item_text">{t('advantages.sustainable.contains')}</span>
							</div>
							<div className="item">
								<span className="item_text">{t('advantages.sustainable.lastUp')}</span>
							</div>
						</div>
					</div>

					<div className="advantages__content_table_item">
						<div className="title">
							<span className="title">{t('advantages.nonToxic.title')}</span>
						</div>
						<div className="items">
							<div className="item">
								<span className="item_text">{t('advantages.nonToxic.oekoTex')}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AdvantagesSection;